import classnames from "classnames";
import { useSelector } from "react-redux";
import { customColorSelector } from "../../../data/selectors/user";
import css from "./Pack.module.scss";

export const Pack = ({ mattressSize, quantity, small = false }) => {
  const customColor = useSelector(state =>
    customColorSelector(state, mattressSize)
  );

  const formattedName = mattressSize
    .replace("_", " ")
    .replace(/\b\w/g, name => name.toUpperCase());

  return (
    <div
      className={classnames(css.pack, { [css["pack--small"]]: small })}
      data-testid="pack"
    >
      <span
        className={classnames(css["pack__count"], {
          [css["pack__count--small"]]: small
        })}
      >
        {quantity}
      </span>
      <span
        style={{ backgroundColor: customColor }}
        className={classnames([
          css["pack__type"],
          css[`pack__type--${mattressSize}`],
          { [css["pack__type--small"]]: small }
        ])}
      >
        {formattedName}
      </span>
    </div>
  );
};
